import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const StyledNavLink = styled(Link)`
  color: ${props => props.isActive ? '#fff' : 'rgba(255, 255, 255, 0.7)'};
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: ${props => props.isActive ? '600' : '400'};
  padding: 0.5rem 1rem;
  margin: 0 0.25rem;
  position: relative;
  transition: color 0.2s ease;
  cursor: pointer;

  &:hover {
    color: #fff;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%) scaleX(0);
    width: ${props => props.isActive ? '80%' : '0'};
    height: 2px;
    background-color: var(--second-color);
    transition: transform 0.2s ease, width 0.2s ease;
  }

  ${props => props.isActive && `
    &::after {
      transform: translateX(-50%) scaleX(1);
      width: 80%;
    }
  `}

  &:hover::after {
    transform: translateX(-50%) scaleX(1);
    width: 80%;
  }
`;

const NavLink = ({ to, children, exact = false }) => {
  const location = useLocation();
  const isActive = exact 
    ? location.pathname === to 
    : location.pathname.startsWith(to);

  return (
    <StyledNavLink to={to} isActive={isActive}>
      {children}
    </StyledNavLink>
  );
};

export default NavLink;

